import { POST_POI_PACKAGE_DATA_TYPE } from '../../constants';

export default function reducer(
  state = {
    poiPoints: [],
    changingStatus: 'initial',
    postPoiPackageData: {
      changingStatus: 'initial',
      data: [],
      error: null,
    },
    getPoiPackageByIdData: {
      changingStatus: 'initial',
      data: {
        poiList: [],
        existingIds: [],
      },
      error: null,
    },
    putPoiPackageRemovePoiData: {
      changingStatus: 'initial',
      data: [],
      error: null,
    },
  },
  action
) {
  switch (action.type) {
    case 'GET_POI_POINTS_STARTED': {
      return {
        ...state,
        changingStatus: 'ongoing',
      };
    }
    case 'GET_POI_POINTS_SUCCESS': {
      return {
        ...state,
        poiPoints: action?.payload?.id ?? [],
        changingStatus: 'success',
      };
    }
    case 'GET_POI_POINTS_FAILED': {
      return {
        ...state,
        changingStatus: 'failed',
      };
    }
    case 'GET_POI_POINTS_RESET': {
      return {
        ...state,
        poiPoints: [],
        changingStatus: 'initial',
      };
    }
    case POST_POI_PACKAGE_DATA_TYPE.POST_POI_PACKAGE_STARTED: {
      return {
        ...state,
        postPoiPackageData: {
          ...state.postPoiPackageData,
          changingStatus: 'ongoing',
        },
      };
    }
    case POST_POI_PACKAGE_DATA_TYPE.POST_POI_PACKAGE_SUCCESS: {
      return {
        ...state,
        postPoiPackageData: {
          ...state.postPoiPackageData,
          data: action.payload,
          changingStatus: 'success',
        },
      };
    }
    case POST_POI_PACKAGE_DATA_TYPE.POST_POI_PACKAGE_FAILED: {
      return {
        ...state,
        postPoiPackageData: {
          ...state.postPoiPackageData,
          error: action.payload,
          changingStatus: 'failed',
        },
      };
    }
    case POST_POI_PACKAGE_DATA_TYPE.POST_POI_PACKAGE_RESET: {
      return {
        ...state,
        postPoiPackageData: {
          ...state.postPoiPackageData,
          data: [],
          changingStatus: 'initial',
        },
      };
    }
    case POST_POI_PACKAGE_DATA_TYPE.GET_POI_PACKAGE_BY_ID_STARTED: {
      return {
        ...state,
        getPoiPackageByIdData: {
          ...state.getPoiPackageByIdData,
          changingStatus: 'ongoing',
        },
      };
    }
    case POST_POI_PACKAGE_DATA_TYPE.GET_POI_PACKAGE_BY_ID_RESET: {
      return {
        ...state,
        getPoiPackageByIdData: {
          ...state.getPoiPackageByIdData,
          data: {
            poiList: [],
            existingIds: [],
          },
          changingStatus: 'initial',
        },
      };
    }
    case POST_POI_PACKAGE_DATA_TYPE.GET_POI_PACKAGE_BY_ID_SUCCESS: {
      const { id } = action.payload;
      const existingIds = [];
      const data =
        id.poiList?.map((item) => {
          const { poiId, poiName, ...rest } = item;
          existingIds.push(poiId);
          return {
            placeDBId: poiId,
            placeName: poiName,
            ...rest,
            isExisiting: true,
          };
        }) ?? [];
      const tempData = {
        ...action.payload.id,
        poiList: data,
        existingIds,
      };
      return {
        ...state,
        getPoiPackageByIdData: {
          ...state.getPoiPackageByIdData,
          data: tempData,
          changingStatus: 'success',
        },
      };
    }
    case POST_POI_PACKAGE_DATA_TYPE.GET_POI_PACKAGE_BY_ID_FAILED: {
      return {
        ...state,
        getPoiPackageByIdData: {
          ...state.getPoiPackageByIdData,
          error: action.payload,
          changingStatus: 'failed',
        },
      };
    }
    case POST_POI_PACKAGE_DATA_TYPE.PUT_POI_PACKAGE_REMOVE_POI_STARTED: {
      return {
        ...state,
        putPoiPackageRemovePoiData: {
          ...state.putPoiPackageRemovePoiData,
          changingStatus: 'ongoing',
        },
      };
    }
    case POST_POI_PACKAGE_DATA_TYPE.PUT_POI_PACKAGE_REMOVE_POI_SUCCESS: {
      return {
        ...state,
        putPoiPackageRemovePoiData: {
          ...state.putPoiPackageRemovePoiData,
          data: action.payload,
          changingStatus: 'success',
        },
      };
    }
    case POST_POI_PACKAGE_DATA_TYPE.PUT_POI_PACKAGE_REMOVE_POI_FAILED: {
      return {
        ...state,
        putPoiPackageRemovePoiData: {
          ...state.putPoiPackageRemovePoiData,
          error: action.payload,
          changingStatus: 'failed',
        },
      };
    }
    case POST_POI_PACKAGE_DATA_TYPE.PUT_POI_PACKAGE_REMOVE_POI_RESET: {
      return {
        ...state,
        putPoiPackageRemovePoiData: {
          ...state.putPoiPackageRemovePoiData,
          data: [],
          changingStatus: 'initial',
        },
      };
    }
    default: {
      return state;
    }
  }
}
